/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IntakesAndOutputsEditorAliases {
  ACTION_DELETE_INTAKES_OUTPUTS = 'action-delete-intakes-outputs',
  AUTOCOMPLETE_DEVICE = 'autocomplete-device',
  AUTOCOMPLETE_RECORD_TIME = 'autocomplete-record-time',
  AUTOCOMPLETE_SIDE = 'autocomplete-side',
  AUTOCOMPLETE_TOPOGRAPHY = 'autocomplete-topography',
  AUTOCOMPLETE_TYPE = 'autocomplete-type',
  DYNAMIC_FIELDS_INTAKES_OUTPUTS = 'dynamic-fields-intakes-outputs',
  DYNAMIC_FIELDS_VISUAL = 'dynamic-fields-visual',
  FETCH_DEVICE = 'fetch-device',
  FETCH_RECORD_TIME = 'fetch-record-time',
  FETCH_SIDE = 'fetch-side',
  FETCH_TOPOGRAPHY = 'fetch-topography',
  FETCH_TYPE = 'fetch-type',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_DEVICE = 'field-device',
  FIELD_OCCURRENCES = 'field-occurrences',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_RECORD_TIME = 'field-record-time',
  FIELD_RETROACTIVE = 'field-retroactive',
  FIELD_SIDE = 'field-side',
  FIELD_TOPOGRAPHY = 'field-topography',
  FIELD_TYPE = 'field-type',
  FIELD_VOLUME = 'field-volume',
  FIELD_WEIGHT = 'field-weight',
  FIELDSET_DYNAMIC_FIELD = 'fieldset-dynamic-field',
  FIELDSET_VISUAL = 'fieldset-visual',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_DATETIME = 'input-datetime',
  INPUT_OCCURRENCES = 'input-occurrences',
  INPUT_VOLUME = 'input-volume',
  INPUT_WEIGHT = 'input-weight',
  INTAKES_AND_OUTPUTS_EDITOR_CONTEXTUAL_BAR = 'intakes-and-outputs-editor-contextual-bar',
  INTAKES_AND_OUTPUTS_EDITOR_FORM = 'intakes-and-outputs-editor-form',
  INTAKES_AND_OUTPUTS_EDITOR_LAYOUT = 'intakes-and-outputs-editor-layout',
  MAPPER_DEVICE = 'mapper-device',
  MAPPER_RECORD_TIME = 'mapper-record-time',
  MAPPER_SIDE = 'mapper-side',
  MAPPER_TOPOGRAPHY = 'mapper-topography',
  MAPPER_TYPE = 'mapper-type',
  RELEASE_BUTTON = 'release-button',
  TEXT_AREA_DESCRIPTION = 'text-area-description',
  TEXT_AREA_RETROACTIVE = 'text-area-retroactive',
  TEXT_DEVICE = 'text-device',
  TEXT_RECORD_TIME = 'text-record-time',
  TEXT_SIDE = 'text-side',
  TEXT_TOPOGRAPHY = 'text-topography',
  TEXT_TYPE = 'text-type',
}
export { IntakesAndOutputsEditorAliases };
